var map = {
	"./AaveLogo.png": 14289,
	"./AaveLogo_h.png": 78247,
	"./ChainlinkLogo.png": 14806,
	"./ChainlinkLogo_h.png": 82478,
	"./Frame.png": 62847,
	"./Frame_.png": 36862,
	"./Group.png": 59024,
	"./Group1.png": 87282,
	"./Group2.png": 7599,
	"./Logo.png": 44766,
	"./Path.png": 60667,
	"./Primary_Logo.png": 3342,
	"./Primary_Logo_h.png": 74805,
	"./blue_bg.png": 59763,
	"./dexview.png": 20069,
	"./dexview_h.png": 57138,
	"./discord.png": 98672,
	"./diver_icon.png": 90940,
	"./diversity.png": 48375,
	"./failed.png": 88996,
	"./fair_icon.png": 16267,
	"./footer_logo.png": 98266,
	"./go_to.png": 90031,
	"./head0.png": 34260,
	"./head1.png": 54080,
	"./head10.png": 54314,
	"./head11.png": 23986,
	"./head12.png": 79403,
	"./head13.png": 46661,
	"./head14.png": 96349,
	"./head15.png": 67271,
	"./head16.png": 2601,
	"./head17.png": 83534,
	"./head18.png": 17251,
	"./head19.png": 24650,
	"./head2.png": 25388,
	"./head3.png": 34819,
	"./head4.png": 149,
	"./head5.png": 26243,
	"./head6.png": 9094,
	"./head7.png": 48656,
	"./head8.png": 58166,
	"./head9.png": 68056,
	"./help.png": 38360,
	"./home_logo.png": 13686,
	"./icon.png": 3534,
	"./language.png": 22507,
	"./left_i.png": 80396,
	"./less_icon.png": 48372,
	"./lessbg.png": 96387,
	"./mobile.png": 17737,
	"./pending.png": 91507,
	"./pinkSale.png": 47168,
	"./pinkSale_h.png": 87253,
	"./play1.png": 44939,
	"./play2.png": 8139,
	"./play3.png": 72528,
	"./predict.png": 3947,
	"./predict1.png": 55821,
	"./predict2.png": 88708,
	"./predict3.png": 66508,
	"./predict4.png": 42330,
	"./predict5.png": 61136,
	"./purple.png": 77391,
	"./right_i.png": 70951,
	"./s_icon.png": 46304,
	"./success.png": 13776,
	"./twitter.png": 77497
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24457;